const logo = require('./logo.png')
const avatar = require('./avatar.png')
const educacion = require('./educacion.png')
const experiecialaboral = require('./experiencialaboral.png')
const proyectos = require('./proyectos.png')
const skills = require('./skills.png')
const agenda = require('./agenda.png')
const blackjack = require('./blackjack.png')
const galeriaImagenes = require('./galeriaImagenes.png')
const carrito = require('./carrito.png')
const fedecv = require('./fedecv.jpg')
const quizApp = require('./quizApp.png')
const portfolio = require('./portfolio.png')
const proyecto = require('./proyecto.png')
const certificadoReact = require('./certificadoReact.jpg')
const certificadoJs = require('./certificadoJs.jpg')
const calendar = require('./calendar.png')
const demoBlackjack = require('./demoBlackjack.mp4')
const cotizadorCriptomonedas = require('./cotizadorCriptomonedas.png')
const clima = require('./clima.png')
const quiscoApp = require('./quiscoApp.png')


module.exports = {
    logo,
    avatar,
    educacion,
    experiecialaboral,
    proyectos,
    skills,
    agenda,
    blackjack,
    galeriaImagenes,
    carrito,
    fedecv,
    quizApp,
    portfolio,
    proyecto,
    certificadoReact,
    certificadoJs,
    calendar,
    demoBlackjack,
    cotizadorCriptomonedas,
    clima,
    quiscoApp
}
